import { client } from "../client";
import type { Paginated, PaginatedFilter } from "../types/axios.types";
import type { PurchaseOrder } from "../types/purchase_orders.types";

export const fetchPurchaseOrderPaginated = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
	centerId?: number,
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	if (centerId) {
		params.append("centerId", centerId.toString());
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<PurchaseOrder[]>>(
		`purchase/orders/`,
		{
			params,
		},
	);
	return response.data;
};

export const fetchPurchaseOrder = async ({
	id,
}: {
	id: string | number | undefined;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<PurchaseOrder>(`purchase/orders/${id}`);
	return response.data;
};
